import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-apdn-range',
  templateUrl: './apdn-range.component.html',
  styleUrls: [],
  standalone: false
})
export class APDNRangeComponent {
  @Input() from: any = null;
  @Input() to: any = null;

  @Output() readonly fromChange = new EventEmitter();
  @Output() readonly toChange = new EventEmitter();

  constructor() {}
}
